<script>
import { mapActions, mapGetters } from "vuex";
import {
  required,
  maxLength,
  requiredIf,
  numeric,
} from "vuelidate/lib/validators";

export default {
  name: "UpdateActionForm",
  data() {
    return {
      id: null,
      name: null,
      registration_method: null,
      visit_grace_period: 30,
      profile_photo: false,
      switch_user_type: false,
      isParentWithoutChildren : false,
      // other
      registration_method_list: [
        {
          id: "PRE_REGISTERED_ONLY",
          name: this.$t("preRegisteration.preRegisteredOnly"),
        },
        {
          id: "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED",
          name: this.$t("preRegisteration.preRegistrationWithApprovalRequired"),
        },
        {
          id: "REGISTRATION_ALLOWED",
          name: this.$t("preRegisteration.registrationAllowed"),
        },
        {
          id: "PRE_REGISTERED_BY_ADMIN",
          name: this.$t("preRegisteration.preRegisteredByAdmin"),
        },
        {
          id: "REGISTRATION_NOT_REQUIRED",
          name: this.$t("preRegisteration.registrationNotRequired"),
        }
      ],
      showMandatoryDataForUserTypesList:[
        "PRE_REGISTERED_BY_ADMIN",
        "REGISTRATION_ALLOWED",
        "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED",
        "PRE_REGISTERED_ONLY"
      ],
      parent_user_type: null,
      submitted: false,
      userTypeDuplication : false,
      auto_approval : false
    };
  },
  validations: {
    name: { required, maxLength: maxLength(20) },
    registration_method: { required },
    visit_grace_period: {
      required: requiredIf(function () {
        return this.onShowGracePeriodInput;
      }),
      numeric,
      maxLength: maxLength(4),
    },
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("updateUserTypes");
    },
    onShowGracePeriodInput(value) {
      !value && (this.visit_grace_period = null);
      value && !this.visit_grace_period && (this.visit_grace_period = 30);
    },
    registration_method(value) {
      console.log("reg", value, this.id, this.getModalInfo);

      const userType = this.getModalInfo.settings.find(
        (item) => item.name == "registration_method"
      );

      if (
        userType.pivot.value !== "REGISTRATION_NOT_REQUIRED" &&
        value.name == this.$t("preRegisteration.registrationNotRequired")
      )
        this.checkChangeRegMethod(this.id);
      else if (userType.pivot.value == "REGISTRATION_ALLOWED")
        this.checkChangeRegAllowed(this.getModalInfo.id);
      else this.resetChangeRegMethodMsg();
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("userType", [
      "getModalState",
      "getLoading",
      "getChangeRegMethodMsg",
    ]),
    showDataMandatorySection(){
      return this.registration_method?.id ? this.showMandatoryDataForUserTypesList.includes(this.registration_method.id) : false;
    },
    onShowGracePeriodInput() {
      if (this.registration_method) {
        return (
          this.registration_method.name == this.$t("preRegisteration.preRegisteredOnly") ||
          this.registration_method.name ==
            this.$t("preRegisteration.preRegistrationWithApprovalRequired")
        );
      }
      return false;
    },
    onShowSwitchUserType() {
      if (this.registration_method) {
        return this.registration_method.name == this.$t("preRegisteration.preRegisteredByAdmin");
      }
      return false;
    },
    onShowUndefinedUsersText() {
      if (this.registration_method) {
        return this.registration_method.name == this.$t("preRegisteration.registrationNotRequired");
      }
      return false;
    },
  },
  methods: {
    ...mapActions("userType", [
      "updateUserType",
      "resetState",
      "resetChangeRegMethodMsg",
      "resetChangeRegAllowedErr",
      "checkChangeRegMethod",
      "checkChangeRegAllowed",
      "fetchUserTypeDuplication",
    ]),
    checkUserTypeDuplication(value){
      this.userTypeDuplication = false;
      this.fetchUserTypeDuplication({entity_id : this.currentEntity.id, user_type_id : this.id, value : value}).then((data)=>{
        // console.log('data', data);
        this.userTypeDuplication = data.data;
      });
    },
    changePreRegistrationMethod() {
      if(this.registration_method){
        this.auto_approval = false;
      }
    },
    onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$error) {
        const {
          id,
          name,
          registration_method,
          visit_grace_period,
          switch_user_type,
          onShowGracePeriodInput,
          profile_photo,
          auto_approval
        } = this;

        if (onShowGracePeriodInput && visit_grace_period < 30) return;
        this.updateUserType({
          id,
          form: {
            userType: {
              name,
            },
            settings: {
              registration_method: registration_method && registration_method.id,
              visit_grace_period: visit_grace_period ? visit_grace_period : 30,
              switch_usertype: switch_user_type ? 1 : 0,
              profile_photo : this.showDataMandatorySection ? Number(profile_photo) : 0,
              auto_approval : auto_approval ? 1 : 0
            },
          },
        }).then(()=>{
          this.$emit('updateUserTypeOrDeleted');
        })
      }
    },
  },
  async beforeMount() {
    const { resetState, getModalInfo } = this;
    resetState();
    this.resetChangeRegMethodMsg();
    // await this.resetChangeRegAllowedErr();
    console.log("getModalInfo", this.getModalInfo);

    const userType = this.getModalInfo.settings.find(
      (item) => item.name == "registration_method"
    );
    if (userType.pivot.value == "REGISTRATION_ALLOWED")
      await this.checkChangeRegAllowed(this.getModalInfo.id);
    if (getModalInfo) {
      const { id, name, settings, parentId, children, auto_approval } = getModalInfo;
      this.name = name;
      this.id = id;
      this.auto_approval = auto_approval ? true : false;
      if(!parentId && !children.length){ // check if user type has not parent or children
        this.isParentWithoutChildren = true;
      } else{
        this.registration_method_list.pop();
      } 

      console.log("this.isParentWithoutChildren", this.isParentWithoutChildren);
      settings.length > 0 &&
        settings.map((setting) => {
          switch (setting.name) {
            case "visit_grace_period":
              return (this.visit_grace_period = setting.pivot.value);
            case "switch_usertype":
              return (this.switch_user_type =
                setting.pivot.value == "0" ? false : true);
            case "registration_method":
              return this.registration_method_list.map((method) => {
                return (
                  method.id == setting.pivot.value &&
                  (this.registration_method = method)
                );
              });
              case "profile_photo":
                return this.profile_photo = !!(Number(setting.pivot.value))
            default:
              return "";
          }
        });
    }
  },
};
</script>

<template>
  <div class="update-user-type-wrapper">
    <div class="modal-main-header">
      <div>
        <h3 class="modal-header-changeType">{{ $t('userTypes.form.editUserType') }}</h3>
      </div>
        <svg
        class="header-close"
        @click="$bvModal.hide('updateUserTypes')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>
    <div class="form-groups">
      <!-- name   -->
      <div class="name mb-3">

        <!-- <label for="name" class="mb-0 no-wrap no-wrap input-label">{{ $t('common.name') }}:</label>
        <b-input
          id="name"
          name="name"
          type="text"
          v-model.trim="name"
          :placeholder="$t('common.enterName')"
          @input="checkUserTypeDuplication"
        /> -->

        <vp-input
          :label="$t('common.name')"
          width="416"
          id="name"
           v-model.trim="name"
          type="text"
          @input="checkUserTypeDuplication"
        />


        <div class="err-wrapper">
          <div v-if="userTypeDuplication">
            <span class="error-value">{{ $t('userTypes.form.userTypeNameAlreadyExists') }}</span>
          </div>
          <div v-if="submitted && !$v.name.required">
            <span class="error-value">{{ $t('userTypes.form.userTypeNameRequired') }}</span>
          </div>
          <div v-else-if="submitted && !$v.name.maxLength">
            <span class="error-value">{{ $t('common.validation.maximumLength20Characters') }}</span>
          </div>
        </div>
      </div>
      <!-- registration-method  -->
      <div class="registration-method mb-3">
        <!-- <label for="method" class="mb-0 no-wrap no-wrap input-label"
          >{{ $t('userTypes.registrationMethod') }}:</label
        > -->
        <div
          class="multi"
          :class="{
            'warning-field':
              getChangeRegMethodMsg &&
              registration_method.id != 'REGISTRATION_ALLOWED',
          }"
        >
          <!-- <multiselect
            id="userstypes"
            v-model="registration_method"
            :options="registration_method_list"
            :placeholder="$t('userTypes.registrationMethod')"
            label="name"
            :show-labels="false"
            :allowEmpty="true"
            :noResultMessage="$t('common.noResults')"
            :disabled="
              getChangeRegMethodMsg &&
              registration_method.id == 'REGISTRATION_ALLOWED'
            "
          >
          <template #noResult>
            {{ $t('common.notes.noElementsFound') }}
          </template>
          </multiselect> -->

        <VpMultiselect class="top-15" zIndex="10" :showPlaceholderIcon="true" width="416" :isLoading="false" :showOptionsBorder="true" 
        :showNoResults="true" v-model="registration_method" label="name" :options="registration_method_list" :allowEmpty="true" :show-labels="false"
        :title="$t('userTypes.registrationMethod')" :disabled="getChangeRegMethodMsg &&
        registration_method.id == 'REGISTRATION_ALLOWED'" :noResultMessage="$t('common.notes.noElementsFound')" 
        @input="changePreRegistrationMethod"
        />

        </div>

        <div class="err-wrapper" style="margin-top: 5px">
          <div v-if="submitted && !$v.registration_method.required">
            <span class="error-value">{{ $t('userTypes.form.registrationMethodRequired') }}</span>
          </div>
        </div>
        <p
          v-if="onShowUndefinedUsersText && !getChangeRegMethodMsg"
          class="mb-0 text-muted"
        >
          {{ $t('userTypes.form.undefinedUsersSignInCompanyAsThisUserTypeIfAdded') }}
        </p>
        <p
          v-if="getChangeRegMethodMsg"
          class="mb-0 text-muted"
          style="color: #f46a6a !important"
        >
          {{ getChangeRegMethodMsg
          }}{{ registration_method.id == "REGISTRATION_ALLOWED" ? "" : "." }}
        </p>
      </div>
      <!-- visit grace period  -->
      <div class="period mb-3" v-if="onShowGracePeriodInput">

        <!-- <label for="period" class="mb-0 no-wrap no-wrap input-label"
          >{{ $t('userTypes.form.visitGracePeriodInMinutes') }}</label
        >
        <b-input
          id="period"
          name="period"
          type="number"
          min="30"
          v-model="visit_grace_period"
          :placeholder="$t('userTypes.form.enterGracePeriodInMinutes')"
        /> -->

        <vp-input
          :label="$t('userTypes.form.enterGracePeriodInMinutes')"
          width="416"
          id="period"
          v-model="visit_grace_period"
          type="number"
          min="30"
        />
        <div class="err-wrapper">
          <div v-if="submitted && !$v.visit_grace_period.required">
            <span class="error-value">{{ $t('userTypes.form.visitGracePeriodRequired') }}</span>
          </div>
          <div
            v-if="submitted && visit_grace_period && visit_grace_period < 30"
          >
            <span class="error-value"
              >{{ $t('userTypes.form.visitGracePeriodMustLeast30Minutes') }}</span
            >
          </div>
          <div v-else-if="submitted && !$v.visit_grace_period.maxLength">
            <span class="error-value">{{ $t('common.validation.maximumLength4Digits') }}</span>
          </div>
        </div>
      </div>

      <div class="registration-method mb-3" v-if="registration_method && registration_method.id == 'PRE_REGISTRATION_WITH_APPROVAL_REQUIRED'">

        <div class="switch-gray-container mt-16">
          <p class="label">{{ $t('userTypes.form.autoApproveVisitRequests') }}</p>
          <b-form-checkbox class="switch-gray toggle-switch" switch size="lg" v-model="auto_approval" />
        </div>

        <p class="auto-approve-note">
          <b>{{ $t('common.notes.note') }}</b>: {{ $t('userTypes.form.visitRequestsAutomaticallyApprovedNote') }}
        </p>
        <hr class="h-line"/>
      </div>


      <!-- switch user type  -->
      <div class="switch-user-type mb-3" v-if="onShowSwitchUserType">
        <b-form-checkbox
          v-model="switch_user_type"
          class="custom-checkbox-primary"
          checked
        >
          {{ $t('userTypes.form.giveUserAbilitySwitchUserType') }}
        </b-form-checkbox>
        <p class="mb-0 text-muted">
          {{ $t('userTypes.form.forExampleStaffMemberMessage') }}
        </p>
        <hr/>
      </div>
    </div>


    <div class="vp" v-if="showDataMandatorySection">
      <p class="vp-mb-12">{{ $t('userTypes.form.dataMandatoryToBeFilledByUser') }}</p>
      <b-form-checkbox
        class="custom-checkbox-primary profile-photo-checkbox"
        checked
        v-model="profile_photo"
      >
      {{ $t('userTypes.form.profilePhoto') }}
      </b-form-checkbox>
    </div>



    <!-- <div class="action-btns">
      
      <button
        :disabled="userTypeDuplication ||
          getLoading ||
          (getChangeRegMethodMsg &&
            registration_method.id != 'REGISTRATION_ALLOWED')
        "
        class="submit-btn btn btn-primary"
        size="md"
        @click="onSubmit"
      >
        <i
          v-if="getLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        <span v-else>{{ $t('common.update') }}</span>
      </button>
      <button
        class="btn btn-outline-danger cancel-btn"
        @click="$bvModal.hide('updateUserTypes')"
      >
        {{ $t('common.cancel') }}
      </button>
    </div> -->

    <div class="line-divider"></div>
    <div class="d-flex justify-content-center">
      <button
      :disabled="userTypeDuplication ||
      getLoading ||
      (getChangeRegMethodMsg &&
        registration_method.id != 'REGISTRATION_ALLOWED')
    "
    class="change-type"
    size="md"
    @click="onSubmit"
      >
      {{ $t('common.update') }}
        <i
          v-if="getLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle rounded"
        ></i>
      </button>
      <button
        :disabled="getLoading"
        @click="$bvModal.hide('updateUserTypes')"
        class="cancel-type"
      >
        {{ $t('common.cancel') }}
      </button>
    </div>

  </div>
</template>
<style lang="scss" scoped>
.update-user-type-wrapper {
  .form-groups {
    padding-bottom: 1%;
  }
  .input-label {
    width: 400px;
  }
  .action-btns {
    margin-top: 40px;
  }
}
</style>


<style lang="scss">
div#updateUserTypes___BV_modal_content_ {
  width: 500px !important;
  border-radius: 26px !important;
  margin-top: 120px;
  .modal-main-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 40px;
    .modal-header-changeType {
      color: #000;
      font-size: 17px;
      font-weight: 700;
      line-height: normal;
      line-height: 100%;
      text-align: center;
    }

    .header-close{
      margin: -8px -10px; 
    }
  }

  .modal-main-header:lang(ar) {
    margin-right: 128px;
  }

  .modal-main-header:not(:lang(ar)){
    margin-left: 153px;
  }

  .modal-main-content {
    width: 416px;
    margin: auto;
    .modal-msg {
      margin-bottom: 32px;
      color: #787878;

      font-size: 16px;

      font-weight: 400;
      width: 414px;

    line-height: 24px;
    letter-spacing: 0%;

    }
  }

  .line-divider {
    height: 1px;
    background-color: #707070;
    opacity: 0.15;
    margin-top: 40px;
    margin-bottom: 24px;
  }

  button.cancel-type {
    width: 112px;
    height: 32px;
    color: #f46a6a;
    margin-inline-start: 16px;
    background-color: transparent;
    border-radius: 26px;
    border: solid 1px #f46a6a;
    text-align: center;

    font-size: 16px;

    font-weight: 400;
    line-height: normal;
  }

  button.change-type {
    width: 112px;
    height: 32px;
    color: #ffffff;
    margin-inline-end: 16px;
    background-color: #103f5e;
    border-radius: 26px;
    border: solid 1px #103f5e;
    text-align: center;

    font-size: 16px;

    font-weight: 400;
    line-height: normal;
    &:disabled {
      opacity: 0.4;
    }
  }

  .auto-approve-note{
    width: 416px !important;
    margin-top: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.25px;
    color: #787878;
  }
}
</style>
